import { getSongsList } from "../../helpers/song_helper.js";
import { songListSuccess } from "./reducer";

export const viewSongs = (eventId = null) => async (dispatch) => {
    let response;
    response = getSongsList(eventId);
    const data = await response;
    if (data) {
      dispatch(songListSuccess(data));
    }
};
